import {Directive, ElementRef, Input, OnDestroy, OnInit} from "@angular/core";
import Tooltip from "bootstrap/js/dist/tooltip";

@Directive({
  selector: '[appTooltip]',
  standalone: true
})
export class TooltipDirective implements OnInit, OnDestroy {
  tooltip: Tooltip | null = null;

  @Input() appTooltip = '';

  constructor(private el: ElementRef) {
    this.el.nativeElement.addEventListener('mouseup', (event: any) => {
      this.hide();
    });
  }

  ngOnInit(): void {
    this.tooltip = new Tooltip(this.el.nativeElement, {title: this.appTooltip});
  }

  ngOnDestroy(): void {
    this.tooltip?.dispose();
  }

  hide(): void {
    this.tooltip?.hide();
  }
}
